"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const menuCategories = [{
  id: "pienvarasto",
  title: "Pienvarastot 1-4 m²",
  description: "Täydellinen ratkaisu kausisäilytykseen, muuttolaatikoille tai harrastusvälineille.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670724/img/small_storage_unit.png",
  className: "md:col-span-2 md:row-span-2 min-h-[400px] md:min-h-[500px]",
  imageContainerClass: "absolute -bottom-10 -right-10 w-[90%] max-w-[500px] md:-bottom-16 md:-right-16 md:w-[85%] md:max-w-[600px]"
}, {
  id: "keskikoko",
  title: "Keskikoko 5-10 m²",
  description: "Mahtuu helposti pienen asunnon irtaimisto tai yrityksen arkistot ja varastotuotteet.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670724/img/medium_storage_unit.png",
  className: "md:col-span-1 md:row-span-2 min-h-[400px] md:min-h-[500px]",
  imageContainerClass: "absolute -bottom-16 -right-16 w-[120%] max-w-[350px] md:-bottom-24 md:-right-20 md:w-[150%] md:max-w-[450px]"
}, {
  id: "suurvarasto",
  title: "Suurvarastot 15+ m²",
  description: "Tilavat hallit suuriin muuttoihin, ajoneuvoille tai tukkutason varastointitarpeisiin.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670724/img/large_warehouse_unit.png",
  className: "md:col-span-3 min-h-[350px] md:min-h-[300px]",
  imageContainerClass: "absolute -bottom-10 -right-10 w-[80%] max-w-[400px] md:top-1/2 md:-translate-y-1/2 md:right-0 md:w-[50%] md:max-w-[500px]"
}];
export default function OurSeasonalIzakaya() {
  const headerReveal = useRevealOnScroll({
    threshold: 0.1
  });
  const gridReveal = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}